import React, { ReactNode } from "react";
import { cn } from "../../utils/cn";

const variants = {
    default: "bg-siemens-deep-blue-8 dark:bg-siemens-elevation-selected border-siemens-divider/30 dark:border-siemens-divider text-siemens-deep-blue-80 dark:text-siemens-text-soft",
    now: "bg-siemens-feedback-green/10 dark:bg-siemens-feedback-green/20 border-siemens-feedback-green/30 text-siemens-feedback-green",
    next: "bg-siemens-feedback-orange/10 dark:bg-siemens-feedback-orange/20 border-siemens-feedback-orange/30 text-siemens-feedback-orange",
    later: "bg-siemens-feedback-blue/10 dark:bg-siemens-feedback-blue/20 border-siemens-feedback-blue/30 text-siemens-feedback-blue",
    unassigned: "bg-siemens-deep-blue-8 dark:bg-siemens-elevation-base-2 border-siemens-divider/30 dark:border-siemens-divider text-siemens-text-soft",
    done: "bg-emerald-100/50 dark:bg-emerald-900/30 border-emerald-300/50 dark:border-emerald-700/50 text-emerald-600 dark:text-emerald-400",
};

export type PillVariant = keyof typeof variants;

interface PillProps {
    children: ReactNode;
    className?: string;
    variant?: PillVariant;
}

export function Pill({ children, className, variant = "default" }: PillProps) {
    return (
        <span className={cn(
            "inline-flex items-center gap-1 rounded-md border px-2 py-1 text-[10px] font-bold tracking-wide uppercase",
            variants[variant] || variants.default,
            className
        )}>
            {children}
        </span>
    );
}

export default Pill;
